module.exports = __webpack_public_path__ + "static/sqlite-ffcc81d940a61957119d68c8da0dbc5e.png";